import { motion } from 'framer-motion';
import { User } from 'lucide-react';

interface UserProfileInfoProps {
  creatorProfile?: {
    username?: string;
    first_name?: string;
    last_name?: string;
    profile_picture?: string;
  };
  isOwnEntry?: boolean;
}

const UserProfileInfo = ({ creatorProfile, isOwnEntry = false }: UserProfileInfoProps) => {
  const displayName = creatorProfile?.first_name && creatorProfile?.last_name
    ? `${creatorProfile.first_name} ${creatorProfile.last_name}`
    : creatorProfile?.username || 'Unknown User';

  const initials = creatorProfile?.first_name && creatorProfile?.last_name
    ? `${creatorProfile.first_name[0]}${creatorProfile.last_name[0]}`
    : creatorProfile?.username?.[0]?.toUpperCase() || 'U';

  return (
    <motion.div 
      className="flex items-center space-x-2"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
    >
      <span className="text-sm text-muted-foreground">
        {isOwnEntry ? 'Von dir' : 'Erstellt von'}
      </span>
      
      <div className="flex items-center space-x-2">
        {/* Profile Avatar */}
        <div className="w-6 h-6 rounded-full overflow-hidden bg-primary/10 flex items-center justify-center flex-shrink-0">
          {creatorProfile?.profile_picture ? (
            <img
              src={creatorProfile.profile_picture}
              alt={displayName}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-primary/20 to-primary/30 flex items-center justify-center">
              <span className="text-xs font-medium text-primary">
                {initials}
              </span>
            </div>
          )}
        </div>
        
        {/* Username */}
        <span className="text-sm font-medium text-primary truncate max-w-24">
          {displayName}
        </span>
      </div>
    </motion.div>
  );
};

export default UserProfileInfo;